<template>
    <div class="default-result">
        <div class="image">
            <img src="../../../assets/images/student-loan-payment-default.svg" alt="LendingTree" />
        </div>
        <h3 class="result-title">Know what the future holds</h3>
        <p class="result-description">Plug in a few quick numbers for an idea of what you’ll be paying.</p>
    </div>
</template>
<script>
    export default {
    };
</script>
